import { lazy } from 'react';

import { getRoutesArray } from './manager';

const LoginPage = lazy(() => import('~/domains/signin/LoginPage'));
const SignUpPage = lazy(() => import('~/domains/signup/SignUpPage'));
const ForgotPasswordPage = lazy(() => import('~/domains/signin/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('~/domains/signin/ResetPasswordPage'));

const ROUTES = [
    {
        path: '/',
        component: LoginPage,
        exact: true,
    },
    {
        path: '/login',
        component: LoginPage,
    },
    {
        path: '/signup',
        component: SignUpPage,
    },
    {
        path: '/recuperacao-senha',
        component: ForgotPasswordPage,
    },
    {
        path: '/redefinicao-senha',
        component: ResetPasswordPage,
    },
];

export default ROUTES;

export const allRoutes = getRoutesArray({
    group: 'root',
    routes: ROUTES,
});
